import { OBM_API_URL } from '@shared/constants/API.constants';

export const mutateClustersConfig = payload => ({
    url: 'clusters',
    method: 'PUT',
    data: payload,
    baseURL: OBM_API_URL,
});
